import { Entity, formatTicker, ThemeSchemaResponse } from '@api';
import { NonLinearStepper } from '@terminal/components/non-linear-stepper/NonLinearStepper';
import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';
import { isDarkTheme } from '@terminal/components/theme-controller/utils/theme-utils/theme-utils';
import { useTranslation } from 'react-i18next';

import styles from './StepperSection.module.scss';

interface StepperSectionProps {
  entity: Entity;
  theme: ThemeSchemaResponse;
  title?: string;
  description?: string;
  activeIndex: number;
}

export const StepperSection = ({
  entity,
  theme,
  title,
  activeIndex,
  description,
}: StepperSectionProps) => {
  const { t } = useTranslation(['widget']);
  const themeName = useThemeStore(state => state.themeName);
  const isDark = isDarkTheme(themeName);
  const logoUrl = isDark
    ? entity.logo_urls.light_png
    : entity.logo_urls.dark_png;

  return (
    <div className={styles.sectionRow} data-testid="stepper-section">
      {title && <div className={styles.titleMedium}>{title}</div>}
      <div className={styles.stepperWrapper}>
        <NonLinearStepper
          steps={[
            {
              logoUrl: theme.logo_url,
              hoverLabel: theme.name,
              connectorLabel: t('widget:themeOverview.drawer.drivenBy'),
              iconColor: 'var(--kg-theme)',
              isSimple: false,
            },
            {
              logoUrl: logoUrl,
              hoverLabel: formatTicker(entity),
              highlightConnector: false,
            },
          ]}
          activeIndex={activeIndex}
          iconSize={23}
        />
      </div>
      {description && <div className={styles.bodySmall}>{description}</div>}
    </div>
  );
};
